import React from 'react'
import { Card, CardBody, CardHeader, Col } from 'reactstrap'
import { H5, H6, Image, LI, P, UL } from '../../../../../AbstractElements'
import { dynamicImage } from '../../../../../Utils'
import SvgIcon from '../../../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons'
import { Link } from 'react-router-dom'
import { gridCardsData } from '../../../../../Data/Miscellaneous/Blog'

export default function GridCards() {
    return (
        <>
            {gridCardsData.map((item) => (
                <Col xxl={4} xl={6} lg={4} sm={6} key={item.id}>
                    <Card className="grid-cards">
                        <CardHeader className="p-0 border-0">
                            <Image className="img-fluid" src={dynamicImage(`blog/grid-${item.gridSrc}`)} alt="" />
                        </CardHeader>
                        <CardBody>
                            <div className="d-flex gap-2 align-items-center">
                                <div className="flex-shrink-0">
                                    <Image className="img-fluid" src={dynamicImage(`blog/about/${item.aboutSrc}`)} alt="avatar" />
                                </div>
                                <div className="flex-grow-1">
                                    <H6>{item.name}</H6>
                                    <P className="mb-0">{item.date}</P>
                                </div><i className="fa fa-ellipsis-v" />
                            </div>
                            <H5>{item.title}</H5>
                            <P>
                                {item.paragraph}
                                <Link className="font-danger mx-1" to={`${process.env.PUBLIC_URL}/miscellaneous/blog/blog-detail`}>{'Read more...'}</Link>
                            </P>
                            <UL className="d-flex gap-3 justify-content-between simple-list flex-row">
                                <LI>{item.views} views</LI>
                                <LI className="blog-like">
                                    <SvgIcon iconId='blog-heart' />
                                </LI>
                            </UL>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </>
    )
}
